// extracted by mini-css-extract-plugin
module.exports = {"downLoadModel":"styles_downLoadModel__2OwUl","logo":"styles_logo__1bKXt"};